import { money } from './logic';
import { CommandDeparture } from './types';

export function bundleTravellerNote(departure: CommandDeparture): string | null {
  return departure.bundle_pax > 0
    ? `Includes ${departure.bundle_pax} LTLE or bundle travellers. Their money isn't in margin yet (being fixed with the new order model).`
    : null;
}

export function cancellationMoneyNote(departure: CommandDeparture): string | null {
  return departure.kept_from_cancellations
    ? `Includes ${money(departure.kept_from_cancellations)} kept from cancellations (Insurance Breakage)`
    : null;
}
